<div class="custom-slider">
  <ngx-slider [(value)]="minorValuePercent" [(highValue)]="majorValuePercent" [options]="optionsValue"></ngx-slider>
</div>

